<template>
  <div v-if="errors.length > 0" class="alert alert-danger">
    <div v-for="(errorMessage, index) in errors" :key="index" v-html="errorMessage"></div>
  </div>
</template>

<script>
export default {
  name: 'ErrorInfo',

  props: {
    errors: {
      required: true,
      type: Array
    }
  }
}
</script>
